import React, { useState, useRef, useEffect } from "react";
import {
	FaSearch,
	FaDollarSign,
	FaShieldAlt,
	FaStar,
	FaKey,
	FaUser,
} from "react-icons/fa";
import { AiOutlineQrcode } from "react-icons/ai";
import {
	FiAlertCircle,
	FiFileText,
	FiCreditCard,
	FiLogOut,
} from "react-icons/fi";
import lupa from "./../../../assets/lupa.png";
import pixIcon from "./../../../assets/pix.png";
import "./SearchModal.css";
import { search } from "src/utils/search";

const searchOptions = search;

export const Search = () => {
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const [text, setText] = useState("");
	const searchRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				searchRef.current &&
				!searchRef.current.contains(event.target as Node)
			) {
				setIsSearchOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const filter = searchOptions.filter((option) => {
		if (text) {
			return option.name.toLowerCase().includes(text.toLowerCase());
		} else {
			return option.name === "Pix" || option.name === "Pagar";
		}
	});

	const ReturnIcons = ({ text }: { text: string }) => {
		const lowerText = text.toLowerCase();
		if (lowerText.includes("qr")) {
			return <AiOutlineQrcode size={24} />;
		} else if (lowerText.includes("pix")) {
			return <img src={pixIcon} alt="Pix Icon" style={{ width: 30 }} />;
		} else if (lowerText.includes("pagar")) {
			return <FiFileText size={24} />;
		} else if (lowerText.includes("cartão")) {
			return <FiCreditCard size={24} />;
		} else if (lowerText.includes("senha")) {
			return <FaKey size={24} />;
		} else if (lowerText.includes("ajuda")) {
			return <FiAlertCircle size={24} />;
		} else if (lowerText.includes("segurança")) {
			return <FaShieldAlt size={24} />;
		} else if (lowerText.includes("conta")) {
			return <FaUser size={24} />;
		} else if (lowerText.includes("favoritos")) {
			return <FaStar size={24} />;
		} else if (lowerText.includes("sair")) {
			return <FiLogOut size={24} />;
		}
		return <FaDollarSign size={24} />;
	};

	return (
		<div ref={searchRef} className="relative w-[25%]">
			<div
				onClick={() => setIsSearchOpen(true)}
				className="hidden lg:flex xl:flex items-center w-full px-4 py-2 1xl:px-6 1xl:py-3 rounded-[25px] bg-[#f5f5f5] gap-3 "
			>
				<img
					src={lupa}
					alt="Search"
					className="1xl:h-[30px] 1xl:w-[30px] 3xl:w-[45px] 3xl:h-[45px] 6xl:w-[55px] 6xl:h-[55px]"
				/>
				<div className="flex-grow flex items-center justify-between">
					{isSearchOpen ? (
						<input
							type="text"
							placeholder="Pesquise aqui o que você procura..."
							value={text}
							onChange={(e) => setText(e.target.value)}
							className="bg-transparent w-full min-w-[16.0625rem] text-[#8BA3CB] 1xl:text-xl 3xl:text-2xl 4xl:text-3xl 6xl:text-4xl focus:outline-none"
						/>
					) : (
						<>
							<p className="hidden xl:flex bg-transparent w-full text-[#8BA3CB] 1xl:text-xl 3xl:text-2xl 4xl:text-3xl 6xl:text-4xl">
								Pesquise aqui o que você procura...
							</p>
							<p className="flex xl:hidden  bg-transparent w-full text-[#8BA3CB] 1xl:text-xl 3xl:text-2xl 4xl:text-3xl 6xl:text-4xl">
								Pesquise aqui...
							</p>
						</>
					)}
					{isSearchOpen}
				</div>
			</div>
			{isSearchOpen && filter.length > 0 && (
				<div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-[15px] shadow-lg z-10 max-h-[300px] w-full 3xl:w-[400px] 6xl:w-[550px] overflow-y-auto">
					{filter.map((option, index) => (
						<div
							key={index}
							className="flex items-center gap-3 px-4 py-3 hover:bg-gray-100 cursor-pointer"
							onClick={() => (window.location.href = option.location)}
						>
							<ReturnIcons text={option.name} />
							<span className="text-[#8BA3CB] 1xl:text-lg 3xl:text-xl 4xl:text-2xl 6xl:text-3xl">
								{option.name}
							</span>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default Search;
